export default {"src":"/_next/static/media/arrow.874778b2.svg","height":6,"width":49,"blurWidth":0,"blurHeight":0};